"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const drynessskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-drynessskin` : '') + (description ? ` desc-drynessskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-drynessskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-drynessskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.24 18.42a.75.75 0 1 1 .5 1.42c-.34.12-.71.2-1.1.26a8.87 8.87 0 0 1-3.6-.26.75.75 0 0 1 .5-1.42c.22.08.5.15.82.2a7.36 7.36 0 0 0 2.06 0l.23-.05c.23-.04.43-.09.6-.15Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85.76A7.84 7.84 0 0 1 12.6.45c.64.19 1.22.5 1.66.95 2.72-.01 5 1 6.5 2.78 1.58 1.85 2.25 4.46 1.82 7.4-.35 2.51-1.03 4.99-2.74 6.85a7.7 7.7 0 0 1-1.8 2.97 7.82 7.82 0 0 1-12.67-2.02 10.84 10.84 0 0 1-4.08-8.36v-.53c.09-5.4 3.3-8.55 6.56-9.73ZM7.1 19.4a6.32 6.32 0 0 0 10.53.14L11.78 17 7.1 19.4Zm4.8-8.78 3.2 4.66-.75.39-.85.43 4.82 2.1a6.32 6.32 0 0 0 .41-2.5l.05-2.83a6.34 6.34 0 0 0-2.75-5.22l-4.13 2.97ZM6.1 15.7v.03c-.03.78.09 1.57.35 2.31L10 16.21l-3.91-1.7v1.2Zm6.07-13.82a6.36 6.36 0 0 0-3.81.28c-2.74 1-5.5 3.63-5.57 8.35V11a9.34 9.34 0 0 0 1.82 5.44 7.86 7.86 0 0 1-.01-.72v-2.84a7.84 7.84 0 0 1 7.56-7.83 1.61 1.61 0 0 0 1.42-1.6 1.38 1.38 0 0 0-.29-.88c-.23-.29-.6-.52-1.12-.67Zm-4.42 11.7 3.98 1.74 1.17-.6-2.22-3.24-2.93 2.1Zm7.3-10.66a3.15 3.15 0 0 1-.59 2.37 7.84 7.84 0 0 1 5.82 7.57v.02l-.04 2.01a16 16 0 0 0 .86-3.53c.37-2.6-.23-4.75-1.48-6.22a6.51 6.51 0 0 0-4.58-2.22ZM8.3 8.06a6.34 6.34 0 0 0-2.21 4.81v.06l3.73-2.67-1.52-2.2Zm3.97-1.52-.3.01c-.85.06-1.67.3-2.42.67l1.49 2.16 3.48-2.5a6.34 6.34 0 0 0-2.1-.35h-.15Z",
    fill: "#232323"
  }));
};
var _default = exports.default = drynessskin;